import { AuthStore } from '@lemsar/storage/stores/auth.store';
import { ResponseTransformer } from '@lemsar/api/transformers/response';
import { Injectable } from '@angular/core';
import { LemsarApiClient } from '@lemsar/api/client';
import { UI } from '@shared/models/ui';
import { Observable } from 'rxjs/Observable';
import { StoreData } from '@shared/module/common/model/store-data';
import { SubVocational } from '@lemsar/common/domains/models/sub-vocational';

/**
 *  @author     Arif Setianto <arifsetiantoo@gmail.com>
 *  @created    22/06/2018
 */
@Injectable()
export class SubVocationalService {
    private _ui: StoreData<UI>;

    public constructor(private api: LemsarApiClient, private authStore: AuthStore) {
        this._ui = new StoreData<UI>(new UI());
    }

    public get ui$(): Observable<UI> {
        return this._ui.stream$;
    }

    public get ui(): UI {
        return this._ui.value;
    }

    public fetchAll(): Observable<SubVocational[]> {
        return this.api.get<any>('sub-vocationals').pipe(ResponseTransformer.toData(), ResponseTransformer.toArrayClass(SubVocational));
    }
}



// WEBPACK FOOTER //
// ./src/lemsar/common/domains/services/sub-vocational.service.ts